export const dashboardContent = {
    'activeFaults':          'Active Faults',
    'actions':               'Actions',
    'applications':          'Applications',
    'area':                  'Area',
    'buildingType':          'Building Type',
    'businessType':          'Business Type',
    'campus':                'Campus',
    'client':                'Client',
    'clients':               'Clients',
    'company':               'Company',
    'createdOn':             'Created On',
    'contextual':            'Contextual',
    'companiesAssociatedTo': 'Companies Associated To',
    'correlationId':         'Correlation ID',
    'date':                  'Date',
    'emailAddress':          'Email Address',
    'enableOrDisable':       'Enable/Disable',
    'equipment':             'Equipment',
    'equipmentType':         'Equipment Type',
    'energyConsumption':     'Energy Consumption',
    'errorMessage':          'Error Message',
    'failureCount':          'Failure Count',
    'faults':                'Faults',
    'faulttype':             'Fault Type',
    'functions':             'Functions',
    'high':                  'High',
    'issueTypes':            'Issue Types',
    'issueType':             'Issue Type',
    'location':              'Location',
    'low':                   'Low',
    'medium':                'Medium',
    'name':                  'Name',
    'priority':              'Priority',
    'rule':                  'Rule',
    'k2aOrCustom':           'K2A/Custom',
    'rules':                 'Rules',
    'score':                 'Score',
    'scores':                'Scores',
    'scoring':               'Scoring',
    'sensor':                'Sensor',
    'sensors':               'Sensors',
    'serviceRequests':       'Service Requests',
    'serviceManagement':     'Services',
    'site':                  'Site',
    'sites':                 'Sites',
    'status':                'Status',
    'summary':               'Summary',
    'system':                'System',
    'systems':               'Systems',
    'systemType':            'System Type',
    'time':                  'Time',
    'timeStamp':             'Time Stamp',
    'target':                'Target',
    'targetCount':           'Target Count',
    'userDetails':           'User Details',
    'userType':              'User Type',
    'schedule':              'Schedule',
    'roles':                 'Roles',
    'rolePermission':        'Role/Permission'
};
